import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  SupervisedUserCircleOutlined,
  VideoCall,
  LocalOfferOutlined,
  EventAvailable,
  SettingsSharp,
  Equalizer,
  EmojiEvents,
  BusinessCenterOutlined,
  Assessment,
} from '@material-ui/icons';
import converge from '../../../assets/images/logo-converge.svg';
import { AppContext } from '../../../app/AppContext';
import { Tooltip } from '@material-ui/core';
import { parseJwt } from '../../../utils/session';
import { isCommunicationsRole } from '../../../utils/roleAccess';

const Menu = () => {
  const location = useLocation();
  const { user } = useContext(AppContext);

  const pathName = location.pathname.split('/')[1];
  const token = window.sessionStorage.getItem('converge.token.private');
  const sessionUser = parseJwt(token);
  const userInfo = user?.role ? user : sessionUser;
  const isCommunications = isCommunicationsRole(userInfo);

  return (
    <div className="component-menu__container">
      <div
        // style={{ backgroundImage: `url(${converge})` }}
        className="converge-image"
      >
        <img src={converge} alt="logo" />
      </div>
      <ul>
        <li className={`${pathName === 'dashboard' ? 'active' : ''}`}>
          <Tooltip title="Registro">
            <Link to="/dashboard">
              <Equalizer />
              <span className="menu-text">Registro</span>
            </Link>
          </Tooltip>
        </li>
        <li className={`${pathName === 'premio' ? 'active' : ''}`}>
          <Tooltip title="Premio">
            <Link to="/premio">
              <EmojiEvents />
              <span className="menu-text">Premio</span>
            </Link>
          </Tooltip>
        </li>
        {!isCommunications && (
          <>
            <li className={`${pathName === 'reuniones' ? 'active' : ''}`}>
              <Tooltip title="Mentorías">
                <Link to="/reuniones">
                  <VideoCall />
                  <span className="menu-text">Mentorías</span>
                </Link>
              </Tooltip>
            </li>
            <li className={`${pathName === 'formacion' ? 'active' : ''}`}>
              <Tooltip title="Formación">
                <Link to="/formacion">
                  <span className="material-symbols-outlined">school</span>
                  <span className="menu-text">Formación</span>
                </Link>
              </Tooltip>
            </li>
          </>
        )}
        <li className={`${pathName === 'usuarios' ? 'active' : ''}`}>
          <Tooltip title="Usuarios">
            <Link to="/usuarios">
              <SupervisedUserCircleOutlined />
              <span className="menu-text">Usuarios</span>
            </Link>
          </Tooltip>
        </li>
        {!isCommunications && (
          <>
            <li className={`${pathName === 'clientes' ? 'active' : ''}`}>
              <Tooltip title="Clientes">
                <Link to="/clientes">
                  <BusinessCenterOutlined />
                  <span className="menu-text">Clientes</span>
                </Link>
              </Tooltip>
            </li>
          </>
        )}
        <li className={`${pathName === 'catalogo' ? 'active' : ''}`}>
          <Tooltip title="Catálogo">
            <Link to="/catalogo">
              <span className="material-symbols-outlined">menu_book</span>
              <span className="menu-text">Catálogo</span>
            </Link>
          </Tooltip>
        </li>
        {!isCommunications && userInfo && userInfo.role && userInfo.role.type !== 'manager' && (
          <>
            <Tooltip title="Pilares">
              <li className={`${pathName === 'pilares' ? 'active' : ''}`}>
                <Link to="/pilares">
                  <LocalOfferOutlined />
                  <span className="menu-text">Pilares</span>
                </Link>
              </li>
            </Tooltip>
            <Tooltip title="Cursos">
              <li className={`${pathName === 'cursos' ? 'active' : ''}`}>
                <Link to="/cursos">
                  <EventAvailable />
                  <span className="menu-text">Cursos</span>
                </Link>
              </li>
            </Tooltip>
          </>
        )}
        <Tooltip title="Novedades">
          <li className={`${pathName === 'novedades' ? 'active' : ''}`}>
            <Link to="/novedades">
              <span className="material-symbols-outlined icon">feed</span>
              <span className="menu-text">Novedades</span>
            </Link>
          </li>
        </Tooltip>
        <Tooltip title="Reportería">
          <li className={`${pathName === 'reporteria' ? 'active' : ''}`}>
            <Link to="/reporteria">
              <Assessment />
              <span className="menu-text">
                Reportería
              </span>
            </Link>
          </li>
        </Tooltip>
        {!isCommunications && userInfo && userInfo.role && userInfo.role.type !== 'manager' && (
          <Tooltip title="Configuraciones">
            <li className={`${pathName === 'configuraciones' ? 'active' : ''}`}>
              <Link to="/configuraciones">
                <SettingsSharp />
                <span className="menu-text">Configuraciones</span>
              </Link>
            </li>
          </Tooltip>
        )}
        {/* <li
          className={`${
            pathName === 'encuestas' ? 'active' : ''
          }`}
        >
          <SpeakerNotes />
          <Link to="/encuestas">
            <span className="menu-text">Encuestas</span>
          </Link>
        </li>
        <li
          className={`${
            pathName === 'informes' && 'active'
          }`}
        >
          <InsertChartOutlined />
          <Link to="/informes">
            <span className="menu-text">Informes</span>
          </Link>
        </li> */}
      </ul>
    </div>
  );
};

export default Menu;
